import Vue from 'vue';
import feathersClient from '../../feathers-client';

export default {
	state: {
		notificationsCount: 0,
		allNotificationsCount: 0,
		notifications: [],
		notificationSettings: '',
		moreNotification: 0,
	},
	getters: {
		notifications: (state) => state.notifications,
		notificationsCount: (state) => state.notificationsCount,
		allNotificationsCount: (state) => state.allNotificationsCount,
		notificationSettings: (state) => state.notificationSettings,
		moreNotification: (state) => state.moreNotification,
	},
	mutations: {
		SET_NOTIFICATIONS: (state, notifications) => {
			state.notifications = notifications;
		},
		MERGE_NOTIFICATIONS: (state, moreNotification) => {
			state.notifications = _.unionBy(state.notifications, moreNotification, 'id');
		},
		SET_ALL_NOTIFICATIONS_COUNT: (state, allNotificationsCount) => {
			state.allNotificationsCount = allNotificationsCount;
		},
		SET_NOTIFICATIONS_COUNT: (state, notificationsCount) => {
			state.notificationsCount = notificationsCount;
		},
		SET_NOTIFICATION_FOR_TRUST: (state, data) => { state.notificationSettings = data; },
	},
	actions: {
		createNotificationSetting: async({ rootGetters }, data) => {
			const results = await feathersClient.service('api/v3/notification-settings').create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});

			return results;
		},
		updateNotificationSetting: async({ rootGetters }, data) => {
			const id = data.id;
			delete data.id;
			const results = await feathersClient.service('api/v3/notification-settings').patch(id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});

			return results;
		},
		getNotificationSettings: async({ rootGetters, commit }, filter) => {
			const results = await feathersClient.service('api/v3/notification-settings').find({
				query: {
					// $role: rootGetters.currentUserRole,
					...filter,
				},
			});
			commit('SET_NOTIFICATION_FOR_TRUST', results.data[0]);
			return results.data;
		},
		readAllNotifications: async () => {
			await feathersClient.service('/api/v3/notifications').patch(null, { viewed: true }, {
				query: {
					$markallRead: true,
				},
			});
		},
		readNotification: async (context, data) => {
			const ids = [];
			ids.push(data.id);
			await feathersClient.service('/api/v3/notifications').patch(data.id, { viewed: data.viewed }, {
				query: {
					notificIds: ids,
					$markRead: true,
				},
			});
			
		},
		setUnreadNotification: async (context, data) => {
			const ids = [];
			ids.push(data.id);
			await feathersClient.service('/api/v3/notifications').patch(data.id, { viewed: true }, {
				query: {
					notificIds: ids,
					$markUnread: true,
				},
			});
		},
		loadMoreNotifications: async ({ commit }, page) => {
			const limit = 10;
			const result = await feathersClient.service('/api/v3/notifications').find({
				query: {
					$limit: limit,
					$skip: (page - 1) * limit,
					$sort: { created: -1 },
				},
			});
			commit('MERGE_NOTIFICATIONS', result.data);
		},

		loadNotificationsCount: async ({ commit }) => {
			const url = '/api/v3/notifications';
			const data = await feathersClient.service(url).find({ query: { $unread: true } });
			commit('SET_NOTIFICATIONS_COUNT', data.total);
			commit('SET_ALL_NOTIFICATIONS_COUNT', data.total);
		},

		deleteNotification: async (context, id) => {
			const url = '/api/v3/notifications';
			await feathersClient.service(url).remove(id);
		},
		deleteAllNotifications: async () => {
			const url = '/api/v3/notifications';
			await feathersClient.service(url).remove(null, { query: { $clearAll: true } });
		},
		loadNotifications: async ({ commit, rootGetters }, page) => {
			// const permissions = ['VIEW_MANAGER_NOTIFICATIONS', 'VIEW_MASTER_NOTIFICATIONS', 'VIEW_TRUST_NOTIFICATIONS'];
			// const findCommon = _.intersection(rootGetters.currentUserRolePermissions, permissions);
			// if (findCommon?.length > 0) {
			// 	const limit = 10;
			// 	const result = await feathersClient.service('/api/v3/notifications').find({
			// 		query: {
			// 			$limit: limit,
			// 			$skip: (page - 1) * limit,
			// 			$sort: { created: -1 },
			// 		},
			// 	});
			// 	commit('SET_NOTIFICATIONS', result.data);
			// }
			const limit = 10;
				const result = await feathersClient.service('/api/v3/notifications').find({
					query: {
						$limit: limit,
						$skip: (page - 1) * limit,
						$sort: { created: -1 },
					},
				});
				commit('SET_NOTIFICATIONS', result.data);
		},
	},
};
